import React from 'react';
const isEven = n => n % 2 === 0;

const NettRow = ({ description, nettRate, retailRate, isHeader, index, initialNettRate, initialRetailRate }) => (
  <div
    style={{
      fontSize: '12px',
      height: isHeader ? '20px' : '25px',
      lineHeight: isHeader ? '20px' : '25px',
      backgroundColor: isEven(index) ? '#f5f5f5' : '',
    }}
  >
    <span style={{ display: 'inline-block', marginLeft: '3%', width: '27%' }}>
      {description}
    </span>
    <span style={{ display: 'inline-block', color: isHeader ? 'rgba(0, 0, 0, 0.54)' : initialRetailRate && initialRetailRate !== retailRate ? '#009688' : 'rgba(0, 0, 0, 0.87)', marginLeft: '5%', width: '30%', textAlign: 'center' }}>
      {isHeader ? 'RETAIL' : `$${retailRate || 0}`}
    </span>
    <span style={{ display: 'inline-block', color: isHeader ? 'rgba(0, 0, 0, 0.54)' : initialNettRate && initialNettRate !== nettRate ? '#009688' : 'rgba(0, 0, 0, 0.87)', marginLeft: '5%', width: '30%', textAlign: 'center' }}>
      {isHeader ? 'NETT' : `$${nettRate || 0}`}
    </span>
  </div>
);

export default NettRow;



// WEBPACK FOOTER //
// ./src/app/components/contracting/mass-rate-change/rates-detail/single-product/rates-table/commission-rate-row.jsx